export default __webpack_public_path__ + "static/media/antivirussettingson.52d29d00.png";